import React from 'react';
import { Alert, Input, Button } from 'antd';
import { greetingMentionsAiDisclosure } from '../receptionistAi.helpers';

interface PresentationSectionProps {
  assistantName: string;
  onAssistantNameChange: (value: string) => void;
  represents: string;
  onRepresentsChange: (value: string) => void;
  transmitsTo: string;
  onTransmitsToChange: (value: string) => void;
  greeting: string;
  onGreetingChange: (value: string) => void;
  onApplyDefaultGreeting: () => void;
}

const PresentationSection: React.FC<PresentationSectionProps> = ({
  assistantName,
  onAssistantNameChange,
  represents,
  onRepresentsChange,
  transmitsTo,
  onTransmitsToChange,
  greeting,
  onGreetingChange,
  onApplyDefaultGreeting,
}) => (
  <>
    <p className="receptionist-ai-detail-page__section-subtitle">
      Les mots qu&apos;elle emploie au début de l&apos;appel.
    </p>

    <div className="receptionist-ai-detail-page__grid">
      <div className="receptionist-ai-detail-page__field receptionist-ai-detail-page__field--full">
        <label htmlFor="receptionist-ai-assistant-name">Prénom de l&apos;assistante</label>
        <Input id="receptionist-ai-assistant-name" value={assistantName} onChange={(e) => onAssistantNameChange(e.target.value)} maxLength={100} placeholder="Donna" />
      </div>

      <div className="receptionist-ai-detail-page__field">
        <label htmlFor="receptionist-ai-represents">Elle représente</label>
        <Input id="receptionist-ai-represents" value={represents} onChange={(e) => onRepresentsChange(e.target.value)} maxLength={100} placeholder="Ex : l'agence Dupont Immobilier" />
        <p className="receptionist-ai-detail-page__hint">Votre agence, votre cabinet, ou vous-même.</p>
      </div>

      <div className="receptionist-ai-detail-page__field">
        <label htmlFor="receptionist-ai-transmits-to">Elle transmet à</label>
        <Input id="receptionist-ai-transmits-to" value={transmitsTo} onChange={(e) => onTransmitsToChange(e.target.value)} maxLength={100} placeholder="Ex : Cédric" />
        <p className="receptionist-ai-detail-page__hint">La personne ou le service qui rappelle. Un prénom, ou « l&apos;agence ».</p>
      </div>

      <div className="receptionist-ai-detail-page__field receptionist-ai-detail-page__field--full">
        <div className="receptionist-ai-detail-page__field-header">
          <label htmlFor="receptionist-ai-greeting">Message d&apos;accueil</label>
          <Button type="link" size="small" onClick={onApplyDefaultGreeting}>Message par défaut</Button>
        </div>
        <Input.TextArea id="receptionist-ai-greeting" value={greeting} onChange={(e) => onGreetingChange(e.target.value)} maxLength={600} showCount rows={3} />
        <p className="receptionist-ai-detail-page__hint">La loi impose d&apos;annoncer une assistante IA. Le message par défaut le fait pour vous.</p>
        {!greetingMentionsAiDisclosure(greeting) && (
          <Alert
            type="warning"
            showIcon
            className="receptionist-ai-detail-page__greeting-warning"
            message={`Votre message ne dit plus que ${assistantName || 'Donna'} est une assistante IA. C'est obligatoire : pensez à le remettre.`}
          />
        )}
      </div>
    </div>
  </>
);

export default PresentationSection;
